var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container d-flex justify-content-center align-items-center"},[(_vm.loadingCheckout)?_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),(_vm.loadingCheckout)?_c('div',[_c('h1',[_vm._v("Loading Checkout ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }